export const lang = {
  zw: "中文",
  yw: "English",
  back: "back",
  search: "search",
  home: "Home",
  newsinfo: "News",
  cmpintr: "About US",
  newproduct: "New Product",
  downloadcenter: "Download Center",
  more: "MORE",
  product: "Product",
  productcenter: "Product Center",
  productcenter1: "产品中心",
  authentication: "International certification",
  advantage: "Our Strengths",
  authentication1: "国际认证",
  advantage1: "我们的优势",
  advtext1:
    "Good sales and after-sales service experience in Europe, America, Japan and other regional markets and global retail markets",
  advtext2:
    "155 sets of high-efficiency injection molding production equipment have been updated, with obvious capacity advantages",
  advtext3:
    "Very professional team and laboratory equipment to ensure production quality control",
  advtext4:
    "Have their own mold workshop, can develop and design new products according to customer needs",
  advtext5: "Professional after-sales service team in the United States",
  advtext6:
    "In the United States, Europe, the United States and Japan, the market has a high visibility and reputation",
  contactus: "CONTACT US",
  add: "Add",
  addtext: "4828 SOUTH HONGMEI ROAD，MINHANG DISTRICT，SHANGHAI，CHINA 200241",
  tel: "Tel",
  fex: "Fex",
  view: "View details",
  about: "About US",
  aboutext1:
    "Shanghai Xinlong Plastic Manufacturing Co., Ltd is a world class manufacturer of a broad range of cable ties, terminals and many other customizes products for the global market. The company currently manages over 200 million RMB ($32,000,000USD) in assets. Our 35,000 square meter facility (377,000 square feet) operates 24 hours per day and 7 days per week. Our 400 employees' ambition is to consistently provide our customers excellent quality products and excellent services. We partner with our customers to develop new products and to meet their specific packaging requirements. Our products, where applicable, are UL and CE certified. We are also ISO9001-2000 approved, meet UL62275, and SGS, RoHs, TUV/SUD, Reach, VDE qualified. It is our mission to achieve and to be recognized as a global leader of excellence to the benefit of our customers, our employees and to the environment.",
  download: "Download",
  filter: "Filter",
  proname: "Product Name",
  pull: "Pulling Force",
  length: "Length",
  width: "Width",
  classifylist: "Classify List",
  productVideo: "Video",
  recommend: "Recommend",
  prodeuctdetail: "Product Detail",
  productname: "Product Name",
  productlength: "Product Length",
  productwidth: "Product Width",
  productpull: "Product Pulling Force",
  briefintroduction: "Product Introduction",
  newsdetail: "News Detail",
  guanzhu: "More exciting, please follow us",
  enterText: "Please enter the search product",
  picture: "Product Picture",
  image: "Drawing",
};
